import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './SimilarVehicles.css';

const SimilarVehicles = ({ currentVehicle }) => {
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!currentVehicle) return;

        const fetchSimilarVehicles = async () => {
            try {
                setLoading(true);

                // Mevcut aracın marka veya modelini kullanarak benzer araçları getir
                const response = await axios.get(`/api/vehicles`, {
                    params: {
                        brand: currentVehicle.brand,
                        limit: 4 // Sadece 4 benzer araç getir
                    }
                });

                if (response.data && response.data.vehicles) {
                    // Mevcut aracı sonuçlardan çıkar
                    const filteredVehicles = response.data.vehicles.filter(
                        vehicle => vehicle._id !== currentVehicle._id
                    ).slice(0, 3); // En fazla 3 benzer araç göster

                    setVehicles(filteredVehicles);
                }
            } catch (err) {
                console.error('Benzer araçları getirme hatası:', err);
                setError('Benzer araçlar yüklenirken bir hata oluştu');
            } finally {
                setLoading(false);
            }
        };

        fetchSimilarVehicles();
    }, [currentVehicle]);

    // Cloudinary URL'sini boyutlandırmak için yardımcı fonksiyon
    const getOptimizedImageUrl = (imageUrl, width = 400, height = 300) => {
        if (!imageUrl) return "https://res.cloudinary.com/dngorcrqv/image/upload/v1746289375/default_zxlbnq.webp";

        // Eğer Cloudinary URL'si ise optimize et
        if (imageUrl.includes('cloudinary.com')) {
            try {
                const parts = imageUrl.split('/upload/');
                if (parts.length !== 2) return imageUrl;

                return `${parts[0]}/upload/w_${width},h_${height},c_fill,q_auto/${parts[1]}`;
            } catch (error) {
                console.error('URL işleme hatası:', error);
                return imageUrl;
            }
        }

        // Cloudinary URL'si değilse varsayılana yönlendir
        return "https://res.cloudinary.com/dngorcrqv/image/upload/v1746289375/default_zxlbnq.webp";
    };

    // Araç için en iyi resmi seç
    const getVehicleImage = (vehicle) => {
        if (!vehicle) return getOptimizedImageUrl(null);

        if (vehicle.images && vehicle.images.length > 0) {
            return getOptimizedImageUrl(vehicle.images[0]);
        }

        if (vehicle.imageUrl) {
            return getOptimizedImageUrl(vehicle.imageUrl);
        }

        return getOptimizedImageUrl(null);
    };

    if (loading) {
        return (
            <Card className="similar-vehicles-card">
                <Card.Header>
                    <h5 className="mb-0">Benzer Araçlar</h5>
                </Card.Header>
                <Card.Body className="text-center py-4">
                    <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </Spinner>
                </Card.Body>
            </Card>
        );
    }

    if (error) {
        return null; // Hata durumunda bileşeni gösterme
    }

    // Benzer araç yoksa gösterme
    if (vehicles.length === 0) {
        return null;
    }

    return (
        <Card className="similar-vehicles-card">
            <Card.Header>
                <h5 className="mb-0">Benzer Araçlar</h5>
            </Card.Header>
            <Card.Body>
                <Row>
                    {vehicles.map(vehicle => (
                        <Col key={vehicle._id} md={4} sm={6} className="mb-3">
                            <Link to={`/vehicles/${vehicle._id}`} className="similar-vehicle-link">
                                <div className="similar-vehicle-card">
                                    <div className="similar-vehicle-image" style={{ height: '120px', overflow: 'hidden' }}>
                                        <img
                                            src={getVehicleImage(vehicle)}
                                            alt={vehicle.title || `${vehicle.brand} ${vehicle.model}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = getOptimizedImageUrl(null);
                                            }}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                        />
                                    </div>
                                    <div className="similar-vehicle-details">
                                        <h6 className="similar-vehicle-title">{vehicle.title || `${vehicle.brand} ${vehicle.model}`}</h6>
                                        <div className="similar-vehicle-specs">
                                            {vehicle.year} • {vehicle.mileage?.toLocaleString()} km • {vehicle.fuelType}
                                        </div>
                                        <div className="similar-vehicle-price">
                                            {vehicle.price?.toLocaleString()} ₺
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </Col>
                    ))}
                </Row>
                <div className="text-center mt-2">
                    <Link to={`/vehicles?brand=${currentVehicle.brand}`} className="more-link">
                        Daha Fazla {currentVehicle.brand} Aracı Gör
                    </Link>
                </div>
            </Card.Body>
        </Card>
    );
};

export default SimilarVehicles;